import { IHeartRate } from 'fitbeat.models';

export class HeartRateData {
  public id: string;
  public heartRateDataPoints: IHeartRate[];

  constructor(id: string, heartRateDataPoints: (number | Date)[][]) {
    this.id = id;
    this.heartRateDataPoints = heartRateDataPoints.map((dataPoint) => ({
      heartRate: dataPoint[0] as number,
      timestamp: new Date(dataPoint[1]) as Date,
    }));
  }
}
